import * as dtos from "@/models/dtos";
import { useStore } from "vuex";
import { MainContainer } from "./MainContainer";
import { TokenClaims } from "./dtos";

export class UserToken {
  Firstname: string;
  Lastname: string;
  Email: string;
  IsAdmin: boolean;
  constructor(token: TokenClaims) {
    this.Firstname = token.given_name;
    this.Lastname = token.family_name;
    this.Email = token.sub;
    this.IsAdmin = token.role === 'odin';
  }

  getDisplayName(): string {
    if (this.Firstname?.length > 0 && this.Lastname?.length > 0)
      return this.Firstname + " " + this.Lastname;
    else return this.Email;
  }
}
